import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["itemLink"]
  static values = {
    detailUrl: String,
    showExpandingPanels: Boolean,
  }

  connect() {
    this.itemLinkTarget.href = this.detailUrlValue
    this.itemLinkTarget.dataset.turbo = this.showExpandingPanelsValue
  }
}
